export default {"src":"/_next/static/media/record.22d7118e.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};